import * as React from 'react'
import EA_Library from "../../images/edgeAnimations/EA_Library.gif"
import CustomizedToYourPatients from "../../images/edgeAnimations/CustomizedToYourPatients.jpg"
import OnTheGo from "../../images/edgeAnimations/OnTheGo.jpg"
import * as style from "./EACarousel.module.css"
import "../../styles/edgeAnimations.css"
// import "../../styles/flickity/flickity.css"
import { useRef, useEffect } from "react"
const EACarousel = () => {
    useEffect(() => {
        //initFlickity();
        const isBrowser = () => typeof window !== "undefined"
        if (isBrowser() && carousel.current) {
            var Flickity = require('flickity-imagesloaded');

            var flkty = new Flickity(carousel.current, {
               imagesLoaded:true,
               wrapAround: true,
               pageDots: false,
               selectCell: 0,
            });
        }
      }, []);
      const carousel = useRef('.carousel');

    return (
        <>
<div id="Features" className={style.featuresSection}>
    <h1 className="text-center">Feature Rich</h1>
    <div className="main-carousel carousel mt-3">
        <div className="carousel-cell">
            <div className="media-wrapper text-center">
                <img alt="TAD" className="img-fluid" src={EA_Library} />
            </div>
            <div className={style.panelContent}>
                <h3 className="c-heading-5">Ever-Expanding Library</h3>
                <div className="c-paragraph-2">
                    <p>New videos are added frequently to keep your library fresh, and up to date with recent trends. You can even suggest the next video to be created.</p>
                </div>
            </div>
        </div>
        <div className="carousel-cell">
            <div className="media-wrapper text-center">
                <img alt="Take your pediatric dental and orthodontic animations with you wherever you go." className="img-fluid" src={OnTheGo} />
            </div>
            <div className={style.panelContent}>
                <h3 className="c-heading-5">Take Animations on the Go</h3>
                <div className="c-paragraph-2">
                    <p>The Edge Animations App lets you take your library of videos wherever you are. Download the free app on your tablet or smartphone to show off the power of Edge Animations anywhere. It’s the perfect complement to your practice management solution.</p>
                </div>
            </div>
        </div>
        <div className="carousel-cell">
            <div className="media-wrapper text-center">
                <img alt="Customizeable pediatric dental and orthodontic animations" className="img-fluid" src={CustomizedToYourPatients} />
            </div>
            <div className={style.panelContent}>
                <h3 className="c-heading-5">Customized to Your Patients</h3>
                <div className="c-paragraph-2">
                    <p>With drag and drop capabilities, virtually any image or movie can be included as well as patient findings. Import images from Edge Imaging, so patients can see themselves. Effortlessly annotate and draw on animations, and add background music to make each presentation unique.</p>
                </div>
            </div>
        </div>
    </div>
    </div>
        </>
    )
}

export default EACarousel
